import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <Link to="/" className="logo">
            <h1>Amchi Mumbai AI</h1>
            <p>Your Mumbai Slang Translator</p>
          </Link>
          <nav className="navigation">
            <Link 
              to="/translate" 
              className={`nav-link ${isActive('/translate') ? 'active' : ''}`}
            >
              Slang Translator
            </Link>
          </nav>
        </div>
      </header>
      <main className="main-content">
        {children}
      </main>
      <footer className="footer">
        <p>&copy; 2024 Amchi Mumbai AI - Mumbai Slang Translator</p>
      </footer>
    </div>
  );
};

export default Layout;